import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsSiderTitle from '../../../components/newsSiderTitle';
import NewsSiderContent from '../../../components/newsSiderContent';
import JpTitle from './jpTitle';
import JpList from './jpList';
import BookList from './bookList';
import FictionList from './fictionList';
import IpadAd from '../../../components/ipadAd';

class NewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                newsSiderTitle0,
                newsSiderContent0,
                newsSiderContent1,
                newsSiderContent2,
                newsSiderContent3,
                newsSiderContentList,
                newsSiderAd,
                ipadAd0,
            },
        } = this.props;

        return (
            <div className={styles.news_sider}>
                <div className={styles.sider_box}>
                    <div id="newsSider_0" className={styles.box}>
                        <Chip
                            id="50059"
                            type="struct"
                            title="评论与政务标题"
                            groupName="要闻区左侧栏"
                            content={newsSiderTitle0}>
                            <NewsSiderTitle type={0} />
                        </Chip>
                        <Chip
                            id="75027"
                            type="recommend"
                            title="评论与政务列表"
                            groupName="要闻区左侧栏"
                            translate="handleNewsSiderContentData"
                            translateOptions={{ index: 0 }}
                            content={newsSiderContent0}>
                            <NewsSiderContent hasSummary />
                        </Chip>
                    </div>
                    <div id="newsSider_1" className={styles.box}>
                        <Chip
                            id="50089"
                            type="struct"
                            title="视频凤凰精品标题"
                            groupName="要闻区左侧栏"
                            content={newsSiderContent1}>
                            <JpTitle />
                        </Chip>
                        <Chip
                            id="75180"
                            type="recommend"
                            title="视频凤凰精品列表"
                            groupName="要闻区左侧栏"
                            translate="handleNewsSiderContentListData"
                            content={newsSiderContentList}>
                            <JpList />
                        </Chip>
                    </div>
                    <div id="newsSider_2" className={styles.box}>
                        <Chip
                            id="50092"
                            type="struct"
                            title="互娱有声书知之列表"
                            groupName="要闻区左侧栏"
                            content={newsSiderContent2}>
                            <BookList />
                        </Chip>
                    </div>
                    <div id="newsSider_3" className={styles.box}>
                        <Chip
                            id="50093"
                            type="struct"
                            title="互娱小说列表"
                            groupName="要闻区左侧栏"
                            content={newsSiderContent3}>
                            <FictionList />
                        </Chip>
                    </div>
                </div>
                <NoSSR>
                    {newsSiderAd ? (
                        <Ad content={newsSiderAd} styleName={styles.newsSiderAd} />
                    ) : (
                        <div className={styles.newsSiderAd}>
                            <Chip id="40102" type="static" title="广告1" groupName="要闻区左侧栏" content={ipadAd0}>
                                <IpadAd />
                            </Chip>
                        </div>
                    )}
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(NewsSider);
